module.exports = __webpack_public_path__ + "static/PMB_sign_logo-f85d9f85024fe890d8bc5beb61d461fc.png";